import { IEnvironment } from './environment.interface';
import { version } from './version';

const apiUrl = 'https://county-dev.azurewebsites.net/';
const apiScope = 'api://674b202f-56f1-4c96-a751-df05a4d621df/User.Read';

export const environment: IEnvironment = {
    production: true,
    debug: true,
    tenant: 'luteaim2.onmicrosoft.com',
    clientId: 'd6314e3b-accf-4728-87aa-d2f9ef00b338',
    baseUrl: 'https://preview.platform.county-rental.co.uk/',
    apiUrl,
    apiScope,
    version,
    protectedResource: [[apiUrl, [apiScope]]],
    appinsightConfig: {
        instrumentationKey: '05d74f18-827a-4cc5-b8b4-c04d10355277',
    },
};
